module.exports = __webpack_public_path__ + "static/media/p6_img3.c4dfeb39.svg";